module.exports = __webpack_public_path__ + "static/media/heating.e377dd6b.jpg";